import React from "react";

import CallBack from "./components/CallBack";
import App from "./components/App";
import Services from "./components/Services";
import Steps from "./components/Steps";
import PreferredPartner from "./components/PreferredPartner";
import Slider from "./components/Slider";
import AboutUs from "../AboutUs/AboutUs";

const Homepage = () => {
  return (
    <div>
      <Slider />
      <Steps />
      <Services />
      <PreferredPartner />
      <App />
      <CallBack />
      <AboutUs />
    </div>
  );
};

export default Homepage;
